'use strict';

/**
 *
 * @name: playlistGroup
 *
 */

import DirectiveTemplate from './nn-playlist-group.directive.html';
import './nn-playlist-group.directive.scss';

function PlaylistGroupDirective(
  Playlist,
  transObject,
  $translate,
  apiLoveService,
  $rootScope,
  playlistAnalytics,
  nnModalsService,
  $http) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      var rootWatchers = {};

      scope.item = scope.content();

      scope.playlistAnalytics = playlistAnalytics;

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] &&
        (!scope.item.jsonData.sources[0].order ||
          !scope.item.jsonData.sources[0].order[0])) {

        return terminate();
      }

      scope.item.title = scope.item.title || $translate.instant('NOWNESS_PLAYLISTS');

      function runPlaylists(playlists) {

        playlists.forEach(function(item) {

          if (scope.item.jsonData.sources.length > 1) {

            scope.item.jsonData.sources.some(function(source, index) {

              if (item.id === source.playlistId) {
                item.index = index;
                return true;
              }
              return false;
            });
          }

          transObject.translate(item);
          transObject.getDuration(item);
          transObject.trueSlug(item);
          transObject.trueSlug(item.user);
        });

        if ($rootScope.profile && !playlists[0].hasOwnProperty('isLoved')) {

          var playlistArray = [];
          playlists.forEach(function(item) {

            playlistArray.push(item.id);
          });

          $http
            .get($rootScope.apiUrlNew + '/playlist/isLoved/' + encodeURIComponent(playlistArray.join()))
            .then(function(res) {

              if (res.data.items) {

                res.data.items.forEach(function(item) {

                  playlists.some(function(pitem) {

                    if (pitem.id === item.id) {

                      pitem.isLoved = item.isLoved;
                      return true;
                    }

                    return false;
                  });
                });
              }
            });
        }
      }

      if (scope.item.jsonData.sources[0].playlistId) {

        scope.cache = scope.item.playlists;
        runPlaylists(scope.cache);
        scope.loaded = true;
      } else {

        var order;

        if (scope.item.jsonData.sources[0].order && scope.item.jsonData.sources[0].order[0]) {

          order = scope.item.jsonData.sources[0].order[0];
        } else {

          order = null;
        }

        Playlist
          .get({
            order: order,
            limit: 4,
            hasVideos: true
          }).$promise
          .then(function(res) {

            scope.cache = res.items;
            runPlaylists(scope.cache);
            scope.loaded = true;
          });
      }


      scope.playlistLove = function(id) {

        var thePlaylist;
        var err = {};

        scope.cache.some(function(item) {

          if (item.id === id) {

            thePlaylist = item;
            return true;
          }

          return false;
        });

        if ($rootScope.profile && $rootScope.profile.id === thePlaylist.user.id) {

          err = {
            data: {
              message: $translate.instant('YOU_CAN_NOT_LOVE_YOUR_OWN_PLAYLIST')
            }
          };
          $rootScope.errors.push(err);
          return;
        }

        if (thePlaylist.isPrivate) {

          err = {
            data: {
              message: $translate.instant('YOU_CAN_NOT_LOVE_A_PRIVATE_PLAYLIST')
            }
          };
          $rootScope.errors.push(err);
          return;
        }

        if (thePlaylist.isLoved === false && $rootScope.profile) {

          apiLoveService
            .lovePlaylist(thePlaylist.id)
            .then(function() {

              thePlaylist.isLoved = true;
              thePlaylist['lovesCount_' + $rootScope.lang2]++;
            }, function(err) {

              $rootScope.errors.push(err.data);
            });
        } else if (thePlaylist.isLoved === true && $rootScope.profile) {

          apiLoveService
            .unlovePlaylist(thePlaylist.id)
            .then(function() {

              thePlaylist.isLoved = false;
              thePlaylist['lovesCount_' + $rootScope.lang2]--;
            }, function(err) {
              $rootScope.errors.push(err.data);
            });
        } else if (!$rootScope.profile) {

          $rootScope.playlistToLove = {
            id: thePlaylist.id,
            thumbnailUrl: thePlaylist.thumbnailUrl,
            title: thePlaylist.translations[$rootScope.lang].title,
          };

          $rootScope.playlistToBeLoved = true;

          rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

            if (newVal) {

              rootWatchers.profile();

              if ($rootScope.profile && $rootScope.profile.id === thePlaylist.user.id) {

                var err = {
                  data: {
                    message: $translate.instant('YOU_CAN_NOT_YOUR_OWN_PLAYLIST')
                  }
                };

                $rootScope.errors.push(err);
                return;
              }

              apiLoveService
                .lovePlaylist(thePlaylist.id)
                .then(function() {

                  thePlaylist.isLoved = true;
                  thePlaylist['lovesCount_' + $rootScope.lang2]++;
                }, function(err) {

                  $rootScope.errors.push(err);
                });
            }
          });

          nnModalsService.showModal('login')
        }
      };

      scope.$on('$destroy', function() {

        Object.keys(rootWatchers)
          .forEach(function(killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });
      });

      scope.baiduTongji = ()=>{
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
      }

    }
  };
}

export default PlaylistGroupDirective;



// WEBPACK FOOTER //
// ./app/pages/playlist/nn-playlist-group/nn-playlist-group.directive.js